const BLOCK_SELECTOR = '.b-latest-events';
const SLIDER_SELECTOR = '.b-latest-events__cards';
const NAV_SELECTOR = '.b-latest-events__nav';
const DESKTOP_BREAKPOINT = 768;
const DESKTOP_MIN_SLIDES = 4;
const MOBILE_MIN_SLIDES = 2;
const RESIZE_DEBOUNCE_MS = 150;

/**
 * Returns a debounced version of the given function.
 *
 * @param {Function} fn    Function to debounce.
 * @param {number}   delay Delay in milliseconds.
 * @return {Function} Debounced function.
 */
const debounce = ( fn, delay ) => {

	let timer;

	return ( ...args ) => {

		clearTimeout( timer );
		timer = setTimeout( () => fn( ...args ), delay );

	};

};

/**
 * Update nav visibility based on the current viewport width and total slide count.
 *
 * @param {HTMLElement} navEl       The nav wrapper element.
 * @param {number}      totalSlides Total number of slides.
 */
const updateNavVisibility = ( navEl, totalSlides ) => {

	if ( ! navEl ) {

		return;

	}

	const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
	const threshold = isDesktop ? DESKTOP_MIN_SLIDES : MOBILE_MIN_SLIDES;

	navEl.hidden = totalSlides <= threshold;

};

/**
 * Initialize a single slider instance.
 *
 * @param {HTMLElement} block The block root element.
 */
const initSlider = ( block ) => {

	const slider = block.querySelector( SLIDER_SELECTOR );

	if ( ! slider || slider.dataset.swiperReady === 'true' ) {

		return;

	}

	const prevEl      = block.querySelector( '.b-latest-events__nav-button--prev' );
	const nextEl      = block.querySelector( '.b-latest-events__nav-button--next' );
	const navEl       = block.querySelector( NAV_SELECTOR );
	const totalSlides = slider.querySelectorAll( '.swiper-slide' ).length;

	updateNavVisibility( navEl, totalSlides );

	// eslint-disable-next-line no-new
	new window.Swiper( slider, {
		slidesPerView: 2,
		spaceBetween: 14,
		watchOverflow: true,
		allowTouchMove: true,
		simulateTouch: true,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
			releaseOnEdges: true,
		},
		grabCursor: true,
		threshold: 8,
		a11y: {
			enabled: true,
			prevSlideMessage: 'Previous tile',
			nextSlideMessage: 'Next tile',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		navigation: ( prevEl && nextEl ) ? { prevEl, nextEl } : false,
		breakpoints: {
			768: {
				slidesPerView: 4,
			},
		},
	} );

	slider.dataset.swiperReady = 'true';

	// Re-evaluate on resize (e.g. rotating the device).
	window.addEventListener( 'resize', debounce( () => updateNavVisibility( navEl, totalSlides ), RESIZE_DEBOUNCE_MS ) );

};

/**
 * Boot all sliders on the page.
 */
const init = () => {

	if ( typeof window.Swiper !== 'function' ) {

		return;

	}

	document.querySelectorAll( BLOCK_SELECTOR ).forEach( initSlider );

};

if ( document.readyState === 'loading' ) {

	document.addEventListener( 'DOMContentLoaded', init );

} else {

	init();

}
